import React from 'react';
import classnames from 'classnames';

import { medhaulIcon } from '../../../assets';

import { LogoLink } from './LogoLink';
import { getLogoMarginStyles } from './logoUtils';
import { defaultLogoPropTypes } from './logoPropTypes';

import styles from './defaultLogo.module.css';

const PRESET_VARIANTS = ['login', 'splash', 'loader'];

export const DefaultLogo = ({
  sm,
  md,
  lg,
  xl,
  className,
  onClick,
  width = 251,
  height = 72,
  variant,
  marginTop,
  marginBottom,
  marginOnImage = false,
}) => {
  const { hasCustomMargin, linkMarginStyle, imageMarginStyle } = getLogoMarginStyles(
    variant,
    marginTop,
    marginBottom,
    marginOnImage
  );

  const usePresetImageMargin = PRESET_VARIANTS.includes(variant) && (lg || xl);

  return (
    <LogoLink
      variant={variant}
      onClick={onClick}
      hasCustomMargin={hasCustomMargin}
      linkMarginStyle={linkMarginStyle}
    >
      <img
        src={medhaulIcon}
        className={classnames({
          [styles.xl]: xl,
          [styles.lg]: lg,
          [styles.md]: md,
          [styles.sm]: sm,
          [styles.presetReset]: usePresetImageMargin,
          [className]: className,
        })}
        style={imageMarginStyle}
        alt="medHaul_logo"
        width={`${width}px`}
        height={`${height}px`}
      />
    </LogoLink>
  );
};

DefaultLogo.propTypes = defaultLogoPropTypes;
